//context
import { useContext, useEffect, useState } from 'react';
import { ActivityFeedContext } from '@/context/ActivityFeedContext';

//helpers
import { formatActivityTime, formatLongDateGroup, getAppDetails, getContentDetails, getExtendedContentDetails, getParentListDetails, getUniqueActivityKey, getUserDetails } from  '@/helpers/ActivityFeed';

//interfaces
import { IActivityProps, UserActivity } from  '@/interfaces/activityFeed';
import { IMeta } from  '@/interfaces/activityFeedNotifications';

//components
import ContentLike from '../notifications/ContentLike/ContentLike';
import ContentPost from '../notifications/ContentPost/ContentPost';



const ContentActivity = ({zIndexNum, isPopOut, activity: {author, contentItem, parentList, parentLists, createdAt, activityType, workspace, isRemovedFromParent, meta}} : IActivityProps) => { 
    const { getNotification, getOpenOnWebLink, likeContent, postCommentOnContent, onArchiveContentClick, userProfileImage, isMultipleAppOrganisation} = useContext(ActivityFeedContext);
    const id = getUniqueActivityKey(activityType, contentItem.id, createdAt, author?.id)
    const notificationDetails = getNotification(id) ?? undefined;
    const [contentMeta, setContentMeta] = useState(meta);

    useEffect(() => {
        setContentMeta(meta);
    }, [meta]);
    
    function handleContentLike(){
        setContentMeta((prev: IMeta) => {
            const updated = {
                ...prev,
                likeCount: prev.hasLiked ? prev.likeCount - 1 : prev.likeCount + 1,
                hasLiked: !prev.hasLiked
            };

            // Persist change
            likeContent(id, workspace.id, contentItem.id, prev.hasLiked);

            return updated;
        });
    }

    function handleArchive(){
        onArchiveContentClick(id, parentList.id, contentItem.id)
    }
    
    if (activityType === UserActivity.contentLike) { 
        return (
            <ContentLike
                zIndexNum={zIndexNum}
                activityId={id}
                isPopOut={isPopOut}
                timeStamp={formatActivityTime(createdAt)} 
                dateStamp={formatLongDateGroup(createdAt)}
                user={getUserDetails(author)} 
                contentAuthor={getUserDetails(contentItem.contentAuthor)}
                content={getContentDetails(contentItem, parentList, workspace, parentLists?.length > 1)} 
                parentList={getParentListDetails(parentList, workspace)}
                appDetails={getAppDetails(workspace, isMultipleAppOrganisation)} 
                getOpenOnWebLink={() => getOpenOnWebLink(contentItem.id)}                      
                notificationDetails={notificationDetails}
                isRemovedFromParentList={isRemovedFromParent}
            />
        )
    } else if (activityType === UserActivity.contentPosted) { 
        return (
            <ContentPost 
                zIndexNum={zIndexNum}
                activityId={id}
                isPopOut={isPopOut}
                timeStamp={formatActivityTime(createdAt)}
                dateStamp={formatLongDateGroup(createdAt)}
                user={getUserDetails(author)}
                content={getExtendedContentDetails(contentItem, parentList, workspace, contentMeta, parentLists?.length > 1)}
                parentList={getParentListDetails(parentList, workspace)}
                appDetails={getAppDetails(workspace, isMultipleAppOrganisation)}
                editorProfileImage={userProfileImage}
                notificationDetails={notificationDetails}
                meta={contentMeta}
                getOpenOnWebLink={() => getOpenOnWebLink(contentItem.id)} 
                onArchiveContentClick={handleArchive} 
                onPostCommentClick={contentMeta.commentsEnabled ? postCommentOnContent : undefined}
                onLikeClick={contentMeta.likesEnabled ? handleContentLike : undefined} 
                isRemovedFromParentList={isRemovedFromParent}
            />
        )
    }
                    
    return null; 
}
export default ContentActivity
